export const RESTRICTION_TAG_TYPES = {
  FORMAT: 'Format',
  QUALITY: 'Quality',
};
